// Consola Operadora V1 - Módulo independiente
// Fuente de datos: solo backend (sin localStorage, sin imports locales)

export interface OperatorCart {
  id: string;
  items: OperatorItem[];
  created_at: string;
  status: string;
}

export interface OperatorItem {
  code: string;
  name: string;
  price: number;
  status: string;
  image?: string | null;
}

// Cargar carrito: solo backend
export async function loadOperatorCart(cartId: string): Promise<OperatorCart | null> {
  try {
    const res = await fetch(`/api/carts/${cartId}`);
    if (!res.ok) return null;
    const data = await res.json();
    const cart = data.cart;
    return {
      id: cart.id,
      items: (cart.items || []).map((i: any) => ({
        code: i.productCode,
        name: i.name,
        price: i.price,
        status: i.status,
        image: i.images?.[0] || null
      })),
      created_at: cart.createdAt,
      status: cart.status
    };
  } catch {
    return null;
  }
}

// Actualizar estado de productos seleccionados: solo backend
export async function updateOperatorItems(
  cartId: string,
  codes: string[],
  newStatus: string
): Promise<boolean> {
  if (codes.length === 0) return false;
  try {
    const res = await fetch(`/api/carts/${cartId}/items`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: codes.map(code => ({
          productCode: code,
          status: newStatus
        }))
      })
    });
    return res.ok;
  } catch {
    return false;
  }
}

// Textos de acción
export const ACTION_LABELS: Record<string, string> = {
  active: 'Liberar producto',
  verifying: 'Verificación de pago',
  sold: 'Vendido'
};

export const ACTION_CONFIRM: Record<string, string> = {
  active: 'liberar',
  verifying: 'marcar como Verificación de pago',
  sold: 'marcar como Vendido'
};
